export type Maybe<T> = T | undefined | null;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  FieldErrorValue: string;
};

export type IDownloadProcedureInput = {
  /** @deprecated Use x-device-id header */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  procedureUid: Scalars['String'];
};

export type IIncreaseViewCountInput = {
  /** @deprecated Use x-device-id header */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  /** @deprecated No longer user */
  deviceIp?: InputMaybe<Scalars['String']>;
  /** @deprecated No longer used */
  deviceUserAgent?: InputMaybe<Scalars['String']>;
  procedureUid: Scalars['String'];
};

export type ILogUserSearchInput = {
  industrySlug?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  topicSlug?: InputMaybe<Scalars['String']>;
};

export type IOrganizationFiltersInput = {
  searchQuery?: InputMaybe<Scalars['String']>;
};

export enum IPaginationCursorType {
  Date = 'DATE',
  MultiSort = 'MULTI_SORT',
  Offset = 'OFFSET'
}

export type IPaginationInput = {
  cursor?: InputMaybe<Scalars['String']>;
  cursorType?: InputMaybe<IPaginationCursorType>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type IProcedureFiltersInput = {
  industry?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IProcedureListingStatus>;
  topic?: InputMaybe<Scalars['String']>;
};

export enum IProcedureListingStatus {
  Draft = 'DRAFT',
  PendingApproval = 'PENDING_APPROVAL',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Retired = 'RETIRED'
}

export enum IProcedureRowChoiceColor {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum IProcedureRowDateSubType {
  Date = 'DATE',
  DateTime = 'DATE_TIME'
}

export enum IProcedureRowType {
  Check = 'CHECK',
  Checklist = 'CHECKLIST',
  Condition = 'CONDITION',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  File = 'FILE',
  FileSignature = 'FILE_SIGNATURE',
  Heading = 'HEADING',
  Meter = 'METER',
  Number = 'NUMBER',
  NumberAmount = 'NUMBER_AMOUNT',
  Radio = 'RADIO',
  RadioStandardTest = 'RADIO_STANDARD_TEST',
  RadioYesnona = 'RADIO_YESNONA',
  Section = 'SECTION',
  Text = 'TEXT'
}

export enum IProcedureSectionType {
  Industry = 'INDUSTRY',
  Topic = 'TOPIC'
}

export type ITopicFiltersInput = {
  importance?: InputMaybe<ITopicImportance>;
};

export enum ITopicImportance {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type ISidebarQueryVariables = Exact<{ [key: string]: never; }>;


export type ISidebarQuery = { __typename: 'Query', industries: Array<{ __typename: 'Industry', slug: string, label: string }>, topics: Array<{ __typename: 'Topic', slug: string, label: string }> };

export type IProcedureListingQueryVariables = Exact<{
  industrySlug?: InputMaybe<Scalars['String']>;
  topicSlug?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  useProcedureList: Scalars['Boolean'];
}>;


export type IProcedureListingQuery = { __typename: 'Query', industry: { __typename: 'Industry', slug: string, label: string } | undefined | null, topic: { __typename: 'Topic', slug: string, label: string } | undefined | null, proceduresSummary?: Array<{ __typename: 'ProceduresSummary', slug: string, label: string, totalCount: number | undefined | null, type: IProcedureSectionType, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> }>, procedures?: { __typename: 'PaginatedProcedures', hasMore: boolean, cursor: string, count: number | undefined | null, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type IProcedureListingMoreQueryVariables = Exact<{
  industrySlug?: InputMaybe<Scalars['String']>;
  topicSlug?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  pagination: IPaginationInput;
}>;


export type IProcedureListingMoreQuery = { __typename: 'Query', procedures: { __typename: 'PaginatedProcedures', hasMore: boolean, cursor: string, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type ILogUserSearchMutationMutationVariables = Exact<{
  input: ILogUserSearchInput;
}>;


export type ILogUserSearchMutationMutation = { __typename: 'Mutation', logUserSearch: { __typename: 'LogUserSearchResponse', success: boolean, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IProcedureListingFragmentFragment = { __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null };

export type IThumbnailFragmentFragment = { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null };

export type IProcedurePageQueryVariables = Exact<{
  uid: Scalars['String'];
}>;


export type IProcedurePageQuery = { __typename: 'Query', procedure: { __typename: 'Procedure', description: string | undefined | null, scoringEnabled: boolean, maxScore: number | undefined | null, introduction: string | undefined | null, uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, source: { __typename: 'ProcedureSource', name: string | undefined | null, url: string | undefined | null } | undefined | null, rows: Array<{ __typename: 'ProcedureRow', id: number, parentId: number | undefined | null, label: string, type: IProcedureRowType, required: boolean, description: string, maxScore: number | undefined | null, condition: string | undefined | null, choices: Array<{ __typename: 'ProcedureRowChoice', label: string, color: IProcedureRowChoiceColor | undefined | null, score: number | undefined | null }> | undefined | null, attachment: { __typename: 'FileAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string } | { __typename: 'ImageAttachment', resizableUrl: string, width: number | undefined | null, height: number | undefined | null, id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string } | { __typename: 'LinkAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string } | undefined | null, attachments: Array<{ __typename: 'FileAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string } | { __typename: 'ImageAttachment', resizableUrl: string, width: number | undefined | null, height: number | undefined | null, id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string } | { __typename: 'LinkAttachment', id: string, mimeType: string, fileName: string, originalUrl: string, createdAt: string }> | undefined | null }>, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null } | undefined | null };

export type ISimilarProceduresQueryVariables = Exact<{
  uid: Scalars['String'];
}>;


export type ISimilarProceduresQuery = { __typename: 'Query', similarProcedures: { __typename: 'PaginatedProcedures', cursor: string, hasMore: boolean, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> } };

export type IIncreaseViewCountMutationMutationVariables = Exact<{
  input: IIncreaseViewCountInput;
}>;


export type IIncreaseViewCountMutationMutation = { __typename: 'Mutation', increaseViewCount: { __typename: 'IncreaseViewCountResponse', success: boolean, newCount: number | undefined | null, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IDownloadProcedureMutationVariables = Exact<{
  input: IDownloadProcedureInput;
}>;


export type IDownloadProcedureMutation = { __typename: 'Mutation', downloadProcedure: { __typename: 'DownloadProcedureResponse', success: boolean, download: { __typename: 'Download', filename: string, url: string } | undefined | null, errors: Array<{ __typename: 'FieldError', fieldPath: string, fieldValue: string, error: string }> | undefined | null } };

export type IProcedurePdfPageQueryVariables = Exact<{
  uid: Scalars['String'];
}>;


export type IProcedurePdfPageQuery = { __typename: 'Query', procedure: { __typename: 'Procedure', uid: string, _pdfHTML: { __typename: 'PdfHTML', header: string, body: string, footer: string } | undefined | null } | undefined | null };

export type IIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type IIndexPageQuery = { __typename: 'Query', proceduresSummary: Array<{ __typename: 'ProceduresSummary', slug: string, label: string, totalCount: number | undefined | null, type: IProcedureSectionType, data: Array<{ __typename: 'Procedure', uid: string, title: string, isFeatured: boolean | undefined | null, listingDate: string, industry: { __typename: 'Industry', slug: string, label: string }, topic: { __typename: 'Topic', slug: string, label: string }, maintainer: { __typename: 'Organization', id: number, name: string, thumbnail: { __typename: 'ImageAttachment', id: string, originalUrl: string, fileName: string, mimeType: string, resizableUrl: string, width: number | undefined | null, height: number | undefined | null } } | undefined | null }> }> };
